import { render, staticRenderFns } from "./ChangeAvatar.vue?vue&type=template&id=739c4f13&"
import script from "./ChangeAvatar.vue?vue&type=script&lang=js&"
export * from "./ChangeAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports